import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddSlotComp from "./Component/AddSlotComp"


const AddSlot =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddSlotComp />
        </div>
        <Footer />
        </>
    )
}

export default AddSlot